import styled from 'styled-components'

const FooterContainer = styled.footer`
    position: relative;
    z-index: 2;
    padding: 48px 24px 32px;
    background: linear-gradient(
        to bottom,
        transparent 0%,
        rgba(0, 0, 0, 0.3) 100%
    );
    border-top: 1px solid rgba(255, 255, 255, 0.05);

    @media (max-width: 768px) {
        padding: 40px 20px 28px;
    }
`

const FooterContent = styled.div`
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
`

const Divider = styled.div`
    width: 40px;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    margin: 0 auto 24px;
`

const CopyrightSection = styled.div`
    margin-bottom: 20px;
`

const CopyrightTitle = styled.p`
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.4);
    letter-spacing: 2px;
    text-transform: uppercase;
    margin: 0 0 12px;
`

const CopyrightText = styled.p`
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.5);
    line-height: 1.8;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 0.7rem;
    }
`

const CopyrightLink = styled.a`
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
        color: rgba(255, 255, 255, 0.9);
    }
`

const FooterLinks = styled.div`
    display: flex;
    justify-content: center;
    gap: 24px;
    margin-bottom: 24px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        gap: 16px;
    }
`

const FooterLink = styled.a`
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.4);
    text-decoration: none;
    letter-spacing: 1px;
    transition: color 0.3s ease;

    &:hover {
        color: rgba(255, 255, 255, 0.8);
    }
`

const SiteInfo = styled.p`
    font-size: 0.65rem;
    color: rgba(255, 255, 255, 0.3);
    letter-spacing: 1px;
    margin: 20px 0 0;

    @media (max-width: 768px) {
        font-size: 0.6rem;
    }
`

const Footer = () => {
    const currentYear = new Date().getFullYear()

    return (
        <FooterContainer>
            <FooterContent>
                <Divider />
                
                <CopyrightSection>
                    <CopyrightTitle>Image Credits</CopyrightTitle>
                    <CopyrightText>
                        Tsukihime -A piece of blue glass moon- © TYPE-MOON
                        <br />
                        Fan artworks by artists on <CopyrightLink href="https://www.pixiv.net" target="_blank" rel="noopener noreferrer">Pixiv</CopyrightLink>
                    </CopyrightText>
                </CopyrightSection>

                <FooterLinks>
                    <FooterLink href="https://typemoon.com" target="_blank" rel="noopener noreferrer">
                        TYPE-MOON
                    </FooterLink>
                </FooterLinks>

                <SiteInfo>
                    © {currentYear} Arcueid.org · Fan Project · Not affiliated with TYPE-MOON
                </SiteInfo>
            </FooterContent>
        </FooterContainer>
    )
}

export default Footer
